var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OpenDialog, OpenUploadWindow, } from '../../state/actions/commands';
import { DriveContextActions } from '../drive-context-actions';
import { CrupdateFolderDialogComponent } from '../../folders/components/crupdate-folder-dialog/crupdate-folder-dialog.component';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
var noopTrue = function () { return true; };
var ɵ0 = noopTrue;
var FolderActions = /** @class */ (function (_super) {
    __extends(FolderActions, _super);
    function FolderActions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.actions = [
            {
                viewName: 'New Folder',
                icon: 'create-new-folder',
                execute: function () {
                    _this.store.dispatch(new OpenDialog(CrupdateFolderDialogComponent, null, 'crupdate-folder-dialog-container'));
                },
                visible: noopTrue,
                separatorAfter: true,
            },
            {
                viewName: 'Upload Files',
                icon: 'cloud-upload',
                execute: function () {
                    _this.openUploadWindow('file');
                },
                visible: noopTrue,
            },
            {
                viewName: 'Upload Folder',
                icon: 'upload-folder-custom',
                execute: function () {
                    _this.openUploadWindow('directory');
                },
                visible: noopTrue,
            },
        ];
        return _this;
    }
    FolderActions.prototype.openUploadWindow = function (type) {
        this.store.dispatch(new OpenUploadWindow(type));
    };
    FolderActions.ngInjectableDef = i0.defineInjectable({ factory: function FolderActions_Factory() { return new FolderActions(i0.inject(i1.Store)); }, token: FolderActions, providedIn: "root" });
    return FolderActions;
}(DriveContextActions));
export { FolderActions };
export { ɵ0 };
